import angular from 'angular';
import AnchorFilter from './anchor.filter';
import FechaLargaFilter from './fechalarga.filter';
import FormatoMilesFilter from './formatomiles.filter';

const MODULE_NAME = 'buscador.filtros';

const ngModule=angular.module(MODULE_NAME, []);


ngModule
            .filter('anchor',AnchorFilter)
            .filter('fecha', require('./fecha.filter'))
            .filter('fechaLarga', FechaLargaFilter)
            .filter('formatoMiles', FormatoMilesFilter)
            .filter('htmlSeguro', require('./html-seguro.filter'));


export default MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/filtros/index.js